import { packageLimit } from '@/libs/packageLimits'

/**
 * Menü öğesinin paket limit kontrolünü yapar
 * @param {Object} menuItem - Menü öğesi
 * @returns {boolean} - Menü öğesi gösterilmeli mi
 */
const checkMenuPackageLimit = menuItem => {
  // Eğer packageLimit tanımlı değilse, menü öğesini göster
  if (!menuItem.packageLimit) {
    return true
  }

  const { subject, limit = 1 } = menuItem.packageLimit
  return packageLimit(subject, limit)
}

/**
 * Menü öğelerini paket limit kontrolünden geçirir
 * @param {Array} menuItems - Menü öğeleri array'i
 * @returns {Array} - Filtrelenmiş menü öğeleri
 */
const filterMenuItemsByPackageLimit = menuItems => menuItems.filter(menuItem => {
  // Header öğeleri her zaman gösterilir
  if (menuItem.header) {
    return true
  }

  // Ana menü öğesi için paket limit kontrolü
  if (!checkMenuPackageLimit(menuItem)) {
    return false
  }

  // Alt menü öğeleri varsa, onları da kontrol et
  if (menuItem.children && Array.isArray(menuItem.children)) {
    // eslint-disable-next-line no-param-reassign
    menuItem.children = filterMenuItemsByPackageLimit(menuItem.children)

    // Eğer hiç alt menü kalmadıysa, ana menüyü de gizle
    if (menuItem.children.length === 0) {
      return false
    }
  }

  return true
})

// Tüm menü öğeleri tanımları
const allMenuItems = [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'BarChart2Icon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Ürünler',
    route: 'Products',
    icon: 'CodesandboxIcon',
    resource: 'PRODUCTS_LIST',
    action: 'read',
    packageLimit: {
      subject: 'PRODUCTS',
      limit: 1,
    },
  },
  {
    title: 'Hizmetler',
    route: 'Services',
    icon: 'CoffeeIcon',
    resource: 'SERVICES_LIST',
    action: 'read',
    packageLimit: {
      subject: 'SERVICES',
      limit: 1,
    },
  },
  {
    title: 'Projeler',
    route: 'Projects',
    icon: 'CropIcon',
    resource: 'PROJECTS_LIST',
    action: 'read',
    packageLimit: {
      subject: 'PROJECTS',
      limit: 1,
    },
  },
  {
    header: 'Tanımlar',
  },
  {
    title: 'Departmanlar',
    route: 'Departments',
    icon: 'BoxIcon',
    resource: 'DEPARTMENTS_LIST',
    action: 'read',
  },
  {
    title: 'Ekipler',
    icon: 'UsersIcon',
    route: 'Teams',
    resource: 'TEAMS_LIST',
  },
  {
    title: 'Doküman Kategorileri',
    route: 'DocumentGroups',
    icon: 'FolderIcon',
    resource: 'DOCUMENT_GROUPS_LIST',
    action: 'read',
  },
  {
    title: 'Ürün Kategorileri',
    route: 'ProductCategories',
    icon: 'FolderIcon',
    resource: 'PRODUCT_CATEGORIES_LIST',
    action: 'read',
  },
  {
    title: 'Hizmet Kategorileri',
    route: 'ServiceCategories',
    icon: 'FolderIcon',
    resource: 'SERVICE_CATEGORIES_LIST',
    action: 'read',
  },
  {
    header: 'Yönetim',
  },
  {
    title: 'Sistem',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
        packageLimit: {
          subject: 'SUBUSERS_MANAGEMENT',
          limit: 1,
        },
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
        packageLimit: {
          subject: 'SUBUSERS_MANAGEMENT',
          limit: 1,
        },
      },
      {
        title: 'İndirme Kayıtları',
        route: 'DownloadLogs',
        resource: 'ADMIN_DOWNLOAD_LOGS',
        action: 'read',
      },
      {
        title: 'Silinmiş Öğeler',
        route: 'TrashBin',
        resource: 'ADMIN_TRASH_BIN',
        action: 'read',
      },
    ],
  },
]

// Menü öğelerini dinamik olarak oluştur
const getMenuItems = () => filterMenuItemsByPackageLimit(allMenuItems)

// Export both default and named export
export { getMenuItems }
export default getMenuItems()
